export default "__VITE_ASSET__DqcXKGDA__"